<template>
    <div class="content">

        <div class="intro">

            <div class="overlay">

                <div class="wrapper">
                    <p class="subline">POSITION</p>
                    <h1 class="headline">{{ career.name }}</h1>
                </div>

            </div>

        </div>  
        
        <div class="bottom__bar">

            <div class="text-wrap">
                <p class="red_text">APPLY</p>
                <p class="regular_text">FORM</p>
                <p class="red_text second">00</p>
            </div>

        </div>


        <div class="career__info">

            <div class="content">

                <p class="subline">POSITION</p>

                <p class="headline">{{ career.name }}</p>

                <div class="short_desc" v-html="career.short_description"></div>

                <media-slider :media="this.career.media" :assetpath="'careers'"></media-slider>

                <div class="career__row">

                    <div class="responsibilities">

                        <p class="subline">YOUR</p>
                        <p class="headline">RESPONSIBILITIES</p>
                        <div class="divider"></div>

                        <div class="text" v-html="career.responsibilities"></div>

                    </div>

                    <div class="qualifications">

                        <p class="subline">REQUIRED</p>
                        <p class="headline">QUALIFICATIONS</p>
                        <div class="divider"></div>

                        <div class="text" v-html="career.qualifications"></div>


                    </div>

                </div>


                <template v-if="career.bonuses">
                
                    <div class="bonus__points">
                        <p class="subline">BONUS POINTS</p>
                        <p class="headline">LEVEL UP</p>
                        <div class="divider"></div>

                        <div class="text" v-html="career.bonuses"></div>
                    </div>

                </template>

            </div>

            <career-form/>

            <AvailableRoles/>

        </div>

    </div>
</template>

<script>
    export default {
        data(){
            return {}
        },
        props: ['career'],
        methods: {}
    }
</script>
<style lang="scss" scoped>

    .content{
        display: flex;
        flex-direction: column;

        .intro{
            position: relative;
            height: 490px;

            background: url('/images/careers/page_header.webp');
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;
            background-color: black;


            .overlay{
                display: block;
                width: 100%;
                height: 100%;
                position: relative;

                background: rgba(92, 44, 144, 0.6);

                .wrapper{
                    display: block;
                    position: absolute;
                    top: 57%; right: 50%;
                    transform: translate(50%, -50%);
                    // width: 976px;
                    width: 100%;
                    max-width: 1020px;
                    height: auto;

                    .subline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 14px;
                        line-height: 17px;
                        display: flex;
                        align-items: center;
                        text-transform: uppercase;

                        color: #ED1163;
                    }

                    h1.headline{
                        font-family: 'DIN Next LT Pro Bold', Tahoma, Verdana, sans-serif;;
                        font-style: normal;
                        // font-weight: 700;
                        font-size: 100px;
                        line-height: 100px;
                        /* or 100% */
                        margin: 0;
                        text-transform: uppercase;

                        color: #FFFFFF;

                        margin-left: -5px;
                    }

                    .description{
                        font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;;
                        font-style: normal;
                        // font-weight: 400;
                        font-size: 18px;
                        line-height: 22px;

                        color: #FFFFFF;

                        margin: 0;
                        margin-top: 22px;
                        // text-align: center;
                        text-align: left;
                        width: 100%;
                        // max-width: 454px;
                        margin-left: 0;
                        margin-right: auto;

                        color: #FFFFFF;
                    }

                }

            }
        }

        .bottom__bar{
            background: linear-gradient(360deg, #1A1A1A -0.25%, #222222 100%);
            height: 64px;
            width: 100%;
            position: relative;

            border-top: 1px solid #ED1163;
            border-bottom: 1px solid #ED1163;

            .text-wrap{
                display: flex;
                flex-direction: row;
                justify-content: center;
                position: relative;
                margin-top: 20px;

                .red_text{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-size: 25px;
                    line-height: 25px;
                    /* or 100% */

                    color: #ED1163;
                    margin: 0;

                    &.second{
                        margin-left: 24px;
                    }
                }

                .regular_text{
                    font-family: 'DIN Next LT Pro Regular', Tahoma, Verdana, sans-serif;
                    font-style: normal;
                    font-size: 25px;
                    line-height: 25px;
                    /* or 100% */

                    color: #ffffff;
                    margin: 0;
                    margin-left: 8px;
                }
            }

            
        }


        .career__info{
            display: block;
            width: 100%;
            background: linear-gradient(360deg, #000 0%, #2A1542 100%);

            .content{
                display: flex;
                flex-direction: column;

                width: 100%;
                max-width: 932px;
                margin: 82px auto;

                .subline{
                    color: #ED1163;
                    font-size: 14px;
                    font-family: "DIN Next LT Pro Bold";
                    margin: 0;
                }

                .headline{
                    color: #FFF;
                    font-size: 30px;
                    font-family: "DIN Next LT Pro Bold";
                    line-height: 30px;
                    text-transform: uppercase;
                    margin: 0;
                    margin-bottom: 57px;
                }

                .short_desc{
                    color: #FFF;
                    font-size: 20px;
                    line-height: 20px;
                    font-family: "DIN Next LT Pro Light";
                    margin: 0;
                    margin-bottom: 106px;

                }


                .career__row{
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    margin-top: 120px;

                    .responsibilities, .qualifications{
                        display: flex;
                        flex-direction: column;
                        
                        width: 100%;
                        max-width: 360px;

                        .subline{
                            color: #ED1163;
                            font-size: 14px;
                            line-height: 14px;
                            font-family: "DIN Next LT Pro Bold";
                            margin: 0;
                        }

                        .headline{
                            color: #FFF;
                            font-size: 30px;
                            line-height: 30px;
                            font-family: "DIN Next LT Pro Bold";
                            margin: 0;
                        }

                        .divider{
                            display: block;
                            background: #ED1163;
                            width: 60px;
                            height: 2px;
                        }

                        .text{
                            color: #FFF;
                            font-size: 20px;
                            line-height: 20px;
                            font-family: "DIN Next LT Pro Light";
                        }
                    }
                }

                .bonus__points{
                    display: flex;
                    flex-direction: column;
                    margin-top: 60px;
                    
                    width: 100%;
                    max-width: 360px;

                    .subline{
                        color: #ED1163;
                        font-size: 14px;
                        line-height: 14px;
                        font-family: "DIN Next LT Pro Bold";
                        margin: 0;
                    }

                    .headline{
                        color: #FFF;
                        font-size: 30px;
                        line-height: 30px;
                        font-family: "DIN Next LT Pro Bold";
                        margin: 0;
                    }

                    .divider{
                        display: block;
                        background: #ED1163;
                        width: 60px;
                        height: 2px;
                    }

                    .text{
                        color: #FFF;
                        font-size: 20px;
                        line-height: 20px;
                        font-family: "DIN Next LT Pro Light";
                    }
                }
            }
        }

    }


    @media screen and (max-width: 836px) {

        .content{

            .intro{
                
                .overlay{

                    .wrapper{
                        width: 100%;

                        .subline{
                            font-size: 20px;
                            line-height: 24px;
                            text-align: center;
                            margin-bottom: 15px;
                            display: block;
                        }

                        h1.headline{
                            font-size: 40px;
                            line-height: 40px;
                            text-align: center;
                        }

                        .keywords{
                            font-size: 16px;
                            line-height: 16px;
                        }

                        a.anim_button{
                            width: 100%;
                            max-width: 245px;
                            height: 35px;
                            
                            p{
                                font-size: 12px;
                                line-height: 40px;
                            }
                        }
                    }

                    .bottom__bar{
                        .text-wrap{
                            .red_text, .regular_text, .red_text.second{
                                font-family: 'DIN Next LT Pro Light', Tahoma, Verdana, sans-serif;
                                font-size: 18px;
                                line-height: 25px;
                            }   
                        }
                    }
                }
            }

            .career__info{

                .content{
                    width: 90%;
                    margin: 24px auto;

                    .short_desc{
                        margin-bottom: 0;
                    }

                    .career__row{
                        flex-direction: column;
                        margin-top: 0;
                    }

                    .bonus__points{
                        margin-top: 0;
                    }
                }
            }
        }

    }

</style>

